import { render } from "./Pago_subcategoriaShow.vue?vue&type=template&id=67e12797"
import script from "./Pago_subcategoriaShow.vue?vue&type=script&lang=js"
export * from "./Pago_subcategoriaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__